type SemigroupConcat<F> = (a: F, b: F) => F;

/**
 * Concatenates an array of given functions from a given 
 * semigroup function and an initial value
 */
export const concatAll =
  <F extends Function>(semigroupConcat: SemigroupConcat<F>, initial: F) =>
  (all: F[]) =>
    all.reduce(semigroupConcat, initial);
